import type { CSSProperties } from 'react';

/**
 * Jetons de la charte MAAT utilisés par la coquille (SYNTHESE §2 ; regles-ux-ui §3.4). Le kit complet est celui de
 * `@lakou/ui` (L04) : la coquille n’en reprend que ce qu’il faut pour ses propres éléments (bandeau, navigation,
 * indicateurs), en styles intégrés pour rester sous le budget de poids du portail client (UX-22).
 */
export const COULEURS = {
  marine: '#383D6C',
  marineFonce: '#262A4E',
  ardoise: '#5D6080',
  bordure: '#8A8FB0',
  boutonPrincipal: '#C2410C',
  indigo: '#34479A',
  ambre: '#8A5A00',
  ambreFond: '#FCEFD9',
  rouge: '#B42318',
  rougeFond: '#FCE8E6',
  orangeBouton: '#C2410C',
  blanc: '#FFFFFF',
  surface: '#F6F5F8',
  /** Filet doux des cartes et des lignes (prototype de démo) : décor seulement, jamais seul pour délimiter un champ. */
  bordureDouce: '#E2E1EA',
} as const;

/** Arrondis et ombres du prototype de démonstration (référence visuelle). */
export const RAYONS = { carte: 12, bouton: 10 } as const;
export const OMBRES = { carte: '0 1px 2px rgba(38, 42, 78, 0.06), 0 4px 16px rgba(38, 42, 78, 0.06)' } as const;

/** Équipe : Poppins (sous-ensemble latin) ; clients : police système, aucune police chargée. */
export const POLICE_EQUIPE = "Poppins, system-ui, -apple-system, 'Segoe UI', sans-serif";
export const POLICE_SYSTEME = "system-ui, -apple-system, 'Segoe UI', sans-serif";

/** Cible tactile minimale (UX-21). */
export const CIBLE_MIN = 44;

export const styleBouton: CSSProperties = {
  minHeight: CIBLE_MIN,
  minWidth: CIBLE_MIN,
  padding: '8px 18px',
  borderRadius: 10,
  border: `1px solid ${COULEURS.marine}`,
  background: COULEURS.blanc,
  color: COULEURS.marine,
  font: 'inherit',
  fontWeight: 600,
  cursor: 'pointer',
};

export const styleBoutonPrincipal: CSSProperties = {
  ...styleBouton,
  border: `1px solid ${COULEURS.boutonPrincipal}`,
  background: COULEURS.boutonPrincipal,
  color: COULEURS.blanc,
  fontWeight: 600,
};

/** Identité MAAT du bandeau (SYNTHESE §2) : l'orange vif reste décoratif (filet, soulignement), jamais du texte. */
export const IDENTITE = {
  orange: '#E5521F',
  corail: '#EE8B77',
  corailClair: '#F2A9A5',
} as const;

/** Titres : Playfair Display, équipe seulement ; les clients gardent la police système (UX-22). */
export const POLICE_TITRES = "'Playfair Display', Georgia, serif";
